import { Box, Modal } from "@mui/material";
import DOMPurify from "dompurify";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";


/**
 * Renders a modal component that displays a summary and topics.
 *
 * @param modalOpen - A boolean indicating whether the modal is open or not.
 * @param handleModalClose - A function to handle the modal close event.
 * @param chatOption - The chat option selected.
 * @param TranscriptModaldata - An object containing the summary and topics data.
 * @param youtubeURL - The YouTube URL to embed in the modal (if chatOption is "youtube").
 * @returns The SummaryModal component.
 */
const TranscriptSummaryModal = ({modalOpen, handleModalClose, TranscriptModaldata}: any) => {

    return (
        // console.log('TranscriptModaldata', TranscriptModaldata),
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={{
                position: "absolute" as "absolute",
                top: "5%",
                left: "10%",

                width: "80%",
                height: "90%",
                overflow: "auto",
                bgcolor: "background.paper",
                boxShadow: 10,
                p: 3,
            }}>
                {
                    TranscriptModaldata?.brief_summary?.issue_summary && TranscriptModaldata?.brief_summary?.issue_summary.length > 0 && 
                    TranscriptModaldata?.brief_summary?.resolution_summary && TranscriptModaldata?.brief_summary?.resolution_summary.length > 0 ? (
                        <div>
                            <h2>Brief Summary</h2>
                            <div
                                    className="answerText"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(TranscriptModaldata?.brief_summary?.resolution_summary.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>").replace(/\#\#\#(.*?)/g, "<strong>$1</strong>")),
                                    }}
                                />
                        </div>
                    ): null
                }
                {
                    TranscriptModaldata?.detailed_summary && TranscriptModaldata?.detailed_summary.length > 0 ? (
                        <div>
                            <h2>Detailed Summary</h2>
                            <div
                                    className="answerText"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(TranscriptModaldata?.detailed_summary.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>").replace(/\#\#\#(.*?)/g, "<strong>$1</strong>")),
                                    }}
                                />
                        </div>
                    ): null
                }
                <div>
                <h2>Conversation Report</h2>
                <DataTable value={TranscriptModaldata?.transcriptions} paginator rows={10} rowsPerPageOptions={[5, 10, 20]}
                stripedRows
                className="p-datatable-sm"
                tableStyle={{ minWidth: '50rem' }}>
                    <Column field="Phrase" header="Conversation"></Column>
                    {/* <Column field="Speaker" header="Speaker" sortable></Column>  */}
                    <Column field="role" header="Speaker" sortable></Column>
                    <Column field="Sentiment" header="Sentiment" sortable></Column>
                    <Column field="Sentiment Confidence" header="Confidence Score" sortable></Column>
                    <Column field="PII Entities" header="PII Entities" sortable></Column>
                    <Column field="Redacted Text" header="Redacted Text" sortable></Column>
                </DataTable>
                </div>
            </Box>
        </Modal>)
}

export default TranscriptSummaryModal;